import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getScaleWidth } from '~/modules/common/charts/timeline/calculations';
import { mapIsoStringtoUtcObject } from '~/modules/common/dates/convert';
import PeriodTotalBlock from './PeriodTotalBlock';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
});

const getPeriodTotalByKey = ({ periodTotals, scale, key }) =>
  periodTotals?.find(
    ({ dateRange }) =>
      `${scale}-${mapIsoStringtoUtcObject(dateRange.startDate).toISODate()}` ===
      key
  );

export const PeriodTotalBlocks = ({
  chartDates,
  scale,
  periodTotals,
  loading = false,
  qeIdTag
}) => {
  const classes = useStyles();
  const cellWidth = getScaleWidth(scale);

  return (
    <div className={classes.root}>
      {chartDates.map(({ key, start }) => {
        const { totalHours } =
          getPeriodTotalByKey({ periodTotals, scale, key }) || {};

        return (
          <PeriodTotalBlock
            key={key}
            width={cellWidth}
            scale={scale}
            totalHours={totalHours}
            loading={loading}
            qeIdTag={qeIdTag ? `${qeIdTag}-${start.toISODate()}` : undefined}
          />
        );
      })}
    </div>
  );
};

PeriodTotalBlocks.propTypes = {
  chartDates: PropTypes.array.isRequired,
  scale: PropTypes.string.isRequired,
  periodTotals: PropTypes.array,
  loading: PropTypes.bool,
  qeIdTag: PropTypes.string
};

export default PeriodTotalBlocks;
